export * from "/vercel/path1/apps/web/src/components/common/Mui/index.tsx"